import { NotificationPreferences } from "@freetech/models/notifications";
import { axiosClient } from "../axiosClient";

export const shared = {
  setInitialPassword: async (password: string) => {
    return await axiosClient.post("/portal/shared/auth/set-initial-password", {
      password,
    });
  },
  trackLogin: async (): Promise<void> => {
    return await axiosClient.post("/portal/shared/auth/track-login");
  },
  submitAIMessage: async (message: string) => {
    return await axiosClient.post("/portal/shared/ai/message", {
      message,
    });
  },
  updateNotificationPreferences: async (
    userId: string,
    preferences: NotificationPreferences
  ) => {
    return await axiosClient.put(
      `/portal/shared/notifications/preferences/${userId}`,
      { preferences }
    );
  },

  getNotificationPreferences: async (
    userId: string
  ): Promise<NotificationPreferences> => {
    const response = await axiosClient.get(
      `/portal/shared/notifications/preferences/${userId}`
    );
    return response.data.preferences;
  },
  sendSlackErrorBoundaryAlert: async (
    userId: string | null,
    pageSource: string,
    errorMessage: string,
    errorStack: string | null,
    errorOriginalStack: string | null
  ) => {
    if (process.env.NODE_ENV !== "production") {
      return;
    }

    return await axiosClient.post(
      "/portal/shared/misc/send-slack-error-boundary-alert",
      {
        userId,
        pageSource,
        errorMessage,
        errorStack,
        errorOriginalStack,
      }
    );
  },
};
